export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const goEnquire = (navigate, requirement, amount) => {
  if (requirement) {
    sessionStorage.setItem("lendx_requirement", requirement);
    window.dispatchEvent(new CustomEvent("lendx:requirement", { detail: requirement }));
  }
  if (amount) {
    sessionStorage.setItem("lendx_amount", amount);
    window.dispatchEvent(new CustomEvent("lendx:amount", { detail: amount }));
  }
  if (document.getElementById("enquiry")) {
    scrollToId("enquiry");
  } else {
    navigate("/contact#enquiry");
  }
};

const SITE = "https://www.lendxpro.com";
const OG_IMAGE = `${SITE}/assets/hero-finance.jpeg`;

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const applySEO = (title, description) => {
  if (typeof document === "undefined") return;
  document.title = title;
  const canonical = SITE + window.location.pathname;
  if (description) upsertMeta("name", "description", description);
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description || "");
  upsertMeta("name", "twitter:image", OG_IMAGE);
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description || "");
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:image", OG_IMAGE);
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:site_name", "LendX");
  upsertMeta("property", "og:locale", "en_IN");
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.rel = "canonical";
    document.head.appendChild(link);
  }
  link.href = canonical;
};

export const setJsonLd = (id, data) => {
  if (typeof document === "undefined") return;
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};
